// React imports
import React, { useState, useEffect } from 'react'

// Package component
import { Slider, Typography } from '@mui/material'
import { Container, Row, Col } from 'react-bootstrap'

// CSS Imports
import '../../stylesheets/BullSlider.css'

function BullSlider({ sliderChange, header, name, value, min, max, step }) {
    // Local state to allow smooth dragging without updating the external model
    const [localValue, setLocalValue] = useState(value);

    // Keep local value in sync if the external value changes (for example reset)
    useEffect(() => {
        setLocalValue(value);
    }, [value]);

    return (
        <Container fluid className='mt-2 px-4 py-2'>
            <Row>
                <Col xs="12" sm="12" md="12" lg="12" xl="12" className='p-0'>
                    <Typography className='BullSlider-Header'>{header}</Typography>
                </Col>
                <Col xs="12" sm="12" md="12" lg="12" xl="12">
                    <Slider className="BullSlider-Slider"
                        id={name}
                        name={name}
                        onChange={(e, newValue) => setLocalValue(newValue)}
                        onChangeCommitted={(e, newValue) => { sliderChange(e, newValue, name) }}
                        min={min}
                        max={max}
                        step={step}
                        value={localValue}
                        valueLabelDisplay="auto"
                        disableSwap
                        color="primary" />
                </Col>
            </Row>
        </Container>
    )
}

export default BullSlider
